var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5942,
    cy: 33.9193,
    r: 33.5942,
    fill: "#5926F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_8811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3535 41.0484C31.1566 40.8515 30.8896 40.7408 30.6112 40.7408H26.7751V27.0979H30.2231C30.6478 27.0979 31.0305 26.8422 31.193 26.4498C31.3555 26.0575 31.2657 25.606 30.9654 25.3057L24.2187 18.559C23.8088 18.149 23.1441 18.149 22.734 18.559L15.9872 25.3057C15.687 25.606 15.5972 26.0575 15.7596 26.4498C15.9221 26.8421 16.3049 27.0979 16.7295 27.0979H20.1776V41.7907C20.1776 44.9253 22.731 47.3384 25.7253 47.3384H35.109C35.5337 47.3384 35.9164 47.0827 36.079 46.6904C36.2414 46.2981 36.1516 45.8465 35.8514 45.5463L31.3535 41.0484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4382 41.3886C51.2757 40.9964 50.8929 40.7406 50.4683 40.7406H47.0202V26.0477C47.0202 22.9131 44.4668 20.5 41.4725 20.5H32.0889C31.6643 20.5 31.2815 20.7557 31.119 21.1481C30.9565 21.5404 31.0463 21.9919 31.3466 22.2922L35.8444 26.7901C36.0412 26.987 36.3083 27.0976 36.5867 27.0976H40.4227V40.7406H36.9746C36.55 40.7406 36.1673 40.9964 36.0048 41.3887C35.8423 41.781 35.9321 42.2326 36.2324 42.5328L42.9791 49.2796C43.389 49.6895 44.0537 49.6895 44.4638 49.2796L51.2106 42.5328C51.5108 42.2324 51.6006 41.7809 51.4382 41.3886Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_8811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8338,
    height: 35.8338,
    fill: "white",
    transform: "translate(15.6797 16.002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConv);
export default __webpack_public_path__ + "static/media/conv.bf07a7378588b2c9b8193b8999b1532a.svg";
export { ForwardRef as ReactComponent };